var _line, _line2, _line3, _line4, _mask, _path, _mask2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 172,
    viewBox: "0 0 266 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 85,
    x2: 266,
    y2: 85,
    stroke: "#1C1D1F",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 99,
    x2: 214,
    y2: 99,
    stroke: "#7A7A7A",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 115,
    x2: 182,
    y2: 115,
    stroke: "#7A7A7A",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 130,
    x2: 153,
    y2: 130,
    stroke: "#7A7A7A",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_867_6281",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196 86C196 77.7267 194.37 69.5345 191.204 61.8909C188.038 54.2474 183.398 47.3024 177.548 41.4523C171.698 35.6022 164.753 30.9616 157.109 27.7956C149.466 24.6295 141.273 23 133 23C124.727 23 116.534 24.6295 108.891 27.7956C101.247 30.9616 94.3024 35.6022 88.4523 41.4523C82.6022 47.3024 77.9616 54.2474 74.7956 61.8909C71.6295 69.5345 70 77.7267 70 86L133 86H196Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196 86C196 77.7267 194.37 69.5345 191.204 61.8909C188.038 54.2474 183.398 47.3024 177.548 41.4523C171.698 35.6022 164.753 30.9616 157.109 27.7956C149.466 24.6295 141.273 23 133 23C124.727 23 116.534 24.6295 108.891 27.7956C101.247 30.9616 94.3024 35.6022 88.4523 41.4523C82.6022 47.3024 77.9616 54.2474 74.7956 61.8909C71.6295 69.5345 70 77.7267 70 86L133 86H196Z",
    stroke: "#1C1D1F",
    strokeWidth: 4,
    mask: "url(#path-5-inside-1_867_6281)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_867_6281",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219 86C219 74.7063 216.776 63.5232 212.454 53.0892C208.132 42.6552 201.797 33.1747 193.811 25.1888C185.825 17.203 176.345 10.8683 165.911 6.54636C155.477 2.22445 144.294 -4.93662e-07 133 0C121.706 4.93663e-07 110.523 2.22446 100.089 6.54636C89.6552 10.8683 80.1747 17.203 72.1888 25.1888C64.203 33.1747 57.8683 42.6552 53.5464 53.0892C49.2245 63.5232 47 74.7063 47 86L133 86H219Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219 86C219 74.7063 216.776 63.5232 212.454 53.0892C208.132 42.6552 201.797 33.1747 193.811 25.1888C185.825 17.203 176.345 10.8683 165.911 6.54636C155.477 2.22445 144.294 -4.93662e-07 133 0C121.706 4.93663e-07 110.523 2.22446 100.089 6.54636C89.6552 10.8683 80.1747 17.203 72.1888 25.1888C64.203 33.1747 57.8683 42.6552 53.5464 53.0892C49.2245 63.5232 47 74.7063 47 86L133 86H219Z",
    stroke: "#1C1D1F",
    strokeWidth: 4,
    mask: "url(#path-6-inside-2_867_6281)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.707 44.2929C132.317 43.9024 131.683 43.9024 131.293 44.2929L124.929 50.6569C124.538 51.0474 124.538 51.6805 124.929 52.0711C125.319 52.4616 125.953 52.4616 126.343 52.0711L132 46.4142L137.657 52.0711C138.047 52.4616 138.681 52.4616 139.071 52.0711C139.462 51.6805 139.462 51.0474 139.071 50.6569L132.707 44.2929ZM133 74L133 45L131 45L131 74L133 74Z",
    fill: "#1C1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.1f744a2eecb10b4a2e1157823df96ef8.svg";
export { ForwardRef as ReactComponent };